export default function SectionsA() {
  return (
    <>
      {/* ===== #about ===== */}
      <section id="about" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">关于女神漫画网</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
              女神漫画网是一个专注免费女神漫画在线下拉式阅读的平台，致力于为广大漫迷提供优质流畅的看漫画体验。
            </p>
          </div>
          <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl p-6 md:p-10 border border-background-200/70">
            <div className="flex flex-col md:flex-row gap-6 items-start">
              <div className="w-16 h-16 md:w-20 md:h-20 flex-shrink-0 rounded-xl bg-primary-100 flex items-center justify-center">
                <i className="ri-book-read-line text-3xl text-primary-500"></i>
              </div>
              <div>
                <h3 className="text-lg md:text-xl font-heading text-foreground-800 mb-3">女神漫画网免费看 · 畅享全集阅读</h3>
                <p className="text-sm md:text-base text-foreground-500 leading-relaxed">
                  女神漫画网成立于对漫画热爱的初心，汇聚海量女神漫画免费全集资源，
                  覆盖韩漫、日漫、国漫等热门品类。本站提供女神漫画免费下拉式阅读模式，
                  摒弃繁琐翻页，让读者沉浸在流畅的阅读节奏中。每日更新追更推荐，
                  确保您不错过任何一部好看的免费漫画大全。女神漫画网免费看，
                  是我们对所有漫迷的承诺。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== #ranking ===== */}
      <section id="ranking" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热门漫画排行榜</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">女神漫画网人气热度排行，看看大家都在追哪些免费全集漫画</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-1 gap-3">
            {[
              { rank: 1, title: '我的女神是校花', genre: '恋爱·校园', heat: '本周最热', desc: '平凡少年与校花女神的甜蜜日常，全集免费下拉式畅读中' },
              { rank: 2, title: '绝世女帝养成记', genre: '古风·逆袭', heat: '热度飙升', desc: '废柴少女逆袭成为一代女帝，韩漫风格精美画风全网热追' },
              { rank: 3, title: '女神降临在我家', genre: '奇幻·日常', heat: '新作上榜', desc: '神秘女神从天而降住进我家，搞笑又温暖的同居故事' },
              { rank: 4, title: '霸道女神爱上我', genre: '都市·甜宠', heat: '口碑佳作', desc: '高冷女神总裁倒追普通上班族，反转甜宠剧情让人欲罢不能' },
              { rank: 5, title: '重生之我是漫画女神', genre: '穿越·逆袭', heat: '持续热门', desc: '漫画家重生到自己笔下的漫画世界，成为万人迷女神' },
              { rank: 6, title: '女神契约者', genre: '战斗·热血', heat: '追更推荐', desc: '签订契约获得女神之力，热血少年踏上拯救世界之旅' },
              { rank: 7, title: '双面女神', genre: '悬疑·都市', heat: '新番推荐', desc: '白天是普通白领夜晚是神秘侠客，双面人生的精彩故事' },
            ].map((item) => (
              <div key={item.rank} className="flex items-center gap-4 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 transition-colors duration-200 cursor-pointer border border-background-200/50">
                <div className={`w-10 h-10 flex-shrink-0 rounded-lg flex items-center justify-center font-heading text-lg ${
                  item.rank === 1 ? 'bg-accent-500 text-background-50' :
                  item.rank === 2 ? 'bg-accent-400 text-background-50' :
                  item.rank === 3 ? 'bg-accent-300 text-foreground-800' :
                  'bg-secondary-100 text-secondary-600'
                }`}>
                  {item.rank}
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 flex-wrap">
                    <h3 className="text-sm md:text-base font-semibold text-foreground-800 whitespace-nowrap">{item.title}</h3>
                    <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-600 whitespace-nowrap">{item.genre}</span>
                  </div>
                  <p className="text-xs md:text-sm text-foreground-400 mt-1 line-clamp-1">{item.desc}</p>
                </div>
                <span className="flex-shrink-0 text-xs font-medium text-primary-500 bg-primary-50 px-2 py-1 rounded-md whitespace-nowrap">{item.heat}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== #media ===== */}
      <section id="media" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-6xl mx-auto px-4 md:px-6">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">精彩漫画推荐</h2>
            <p className="mt-3 text-foreground-500 text-sm md:text-base">女神漫画网精选热门免费女神漫画在线下拉式阅读推荐</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
            <div className="group cursor-pointer">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Beautiful%20manga%20cover%20art%20in%20vibrant%20warm%20colors%2C%20anime%20style%20female%20character%20portrait%2C%20soft%20cream%20background%2C%20coral%20and%20amber%20accent%20details%2C%20Japanese%20comic%20illustration%20style%2C%20clean%20composition%2C%20warm%20lighting%2C%20delicate%20linework&width=600&height=800&seq=media-01&orientation=portrait" alt="女神漫画网推荐 - 校园女神录" title="女神漫画网免费看 - 校园女神录" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 w-8 h-8 rounded-full bg-background-50/90 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-primary-500 text-base"></i>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-700 text-center whitespace-nowrap">校园女神录</h3>
              <p className="text-xs text-foreground-400 text-center mt-0.5">校园·纯爱</p>
            </div>
            <div className="group cursor-pointer">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Beautiful%20manga%20cover%20art%20fantasy%20theme%20with%20female%20warrior%20character%2C%20warm%20coral%20and%20amber%20tones%2C%20soft%20cream%20background%2C%20Japanese%20anime%20illustration%20style%2C%20magical%20atmosphere%2C%20clean%20composition%2C%20delicate%20linework%2C%20vibrant%20warm%20lighting&width=600&height=800&seq=media-02&orientation=portrait" alt="女神漫画网推荐 - 女神御兽师" title="女神漫画网免费看 - 女神御兽师" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 w-8 h-8 rounded-full bg-background-50/90 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-primary-500 text-base"></i>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-700 text-center whitespace-nowrap">女神御兽师</h3>
              <p className="text-xs text-foreground-400 text-center mt-0.5">奇幻·冒险</p>
            </div>
            <div className="group cursor-pointer">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Mysterious%20manga%20cover%20art%20with%20dark%20elegant%20female%20character%2C%20warm%20amber%20accents%20on%20dark%20cream%20background%2C%20Japanese%20anime%20style%2C%20suspenseful%20atmosphere%2C%20clean%20illustration%2C%20delicate%20linework%2C%20professional%20manga%20quality&width=600&height=800&seq=media-03&orientation=portrait" alt="女神漫画网推荐 - 暗夜女神" title="女神漫画网免费看 - 暗夜女神" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 w-8 h-8 rounded-full bg-background-50/90 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-primary-500 text-base"></i>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-700 text-center whitespace-nowrap">暗夜女神</h3>
              <p className="text-xs text-foreground-400 text-center mt-0.5">悬疑·异能</p>
            </div>
            <div className="group cursor-pointer">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Warm%20cozy%20manga%20cover%20art%20with%20gentle%20female%20character%20in%20cafe%20setting%2C%20soft%20coral%20and%20cream%20tones%2C%20Japanese%20anime%20illustration%2C%20healing%20slice%20of%20life%20atmosphere%2C%20delicate%20linework%2C%20clean%20composition%2C%20warm%20lighting&width=600&height=800&seq=media-04&orientation=portrait" alt="女神漫画网推荐 - 女神咖啡馆" title="女神漫画网免费看 - 女神咖啡馆" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 w-8 h-8 rounded-full bg-background-50/90 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-primary-500 text-base"></i>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-700 text-center whitespace-nowrap">女神咖啡馆</h3>
              <p className="text-xs text-foreground-400 text-center mt-0.5">日常·治愈</p>
            </div>
            <div className="group cursor-pointer">
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden mb-3 bg-secondary-100">
                <img src="https://readdy.ai/api/search-image?query=Dynamic%20action%20manga%20cover%20art%20with%20powerful%20female%20fighter%20character%2C%20warm%20coral%20and%20amber%20energy%20effects%2C%20Japanese%20anime%20style%2C%20cream%20background%2C%20intense%20battle%20atmosphere%2C%20clean%20illustration%2C%20delicate%20linework&width=600&height=800&seq=media-05&orientation=portrait" alt="女神漫画网推荐 - 女神武斗传" title="女神漫画网免费看 - 女神武斗传" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3 w-8 h-8 rounded-full bg-background-50/90 flex items-center justify-center">
                  <i className="ri-play-circle-fill text-primary-500 text-base"></i>
                </div>
              </div>
              <h3 className="text-sm font-medium text-foreground-700 text-center whitespace-nowrap">女神武斗传</h3>
              <p className="text-xs text-foreground-400 text-center mt-0.5">热血·格斗</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== #contact ===== */}
      <section id="contact" className="py-16 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">联系我们</h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">欢迎漫画作者投稿与合作，女神漫画网期待与您共创精彩的免费女神漫画在线阅读体验</p>
          <div className="mt-8 bg-background-100 rounded-2xl p-8 border border-background-200/70">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="flex flex-col items-center gap-2 p-4">
                <div className="w-12 h-12 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-mail-line text-xl text-primary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-700">投稿邮箱</h3>
                <p className="text-xs text-foreground-400">contact@nvshenmanhua.com</p>
              </div>
              <div className="flex flex-col items-center gap-2 p-4">
                <div className="w-12 h-12 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-wechat-line text-xl text-accent-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-700">官方微信</h3>
                <p className="text-xs text-foreground-400">女神漫画网官方</p>
              </div>
              <div className="flex flex-col items-center gap-2 p-4">
                <div className="w-12 h-12 rounded-full bg-secondary-100 flex items-center justify-center">
                  <i className="ri-message-3-line text-xl text-secondary-500"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-700">合作咨询</h3>
                <p className="text-xs text-foreground-400">商务合作与广告投放</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== #app ===== */}
      <section id="app" className="py-16 md:py-20 bg-background-100">
        <div className="max-w-4xl mx-auto px-4 md:px-6">
          <div className="flex flex-col md:flex-row items-center gap-8 bg-background-50 rounded-2xl p-8 md:p-12 border border-background-200/70">
            <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-2xl bg-primary-500 flex items-center justify-center">
              <i className="ri-smartphone-line text-4xl text-background-50"></i>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900">手机端畅享阅读</h2>
              <p className="mt-3 text-sm md:text-base text-foreground-500 leading-relaxed">
                女神漫画网完美适配手机浏览器，支持女神漫画免费下拉式在线阅读模式。
                无需下载 App，打开浏览器即可畅享全部女神漫画免费全集，
                丝滑滚动，随时随地追更好看的免费漫画大全。
              </p>
              <div className="mt-5 flex flex-wrap items-center justify-center md:justify-start gap-3">
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400 bg-secondary-50 px-3 py-1.5 rounded-full">
                  <i className="ri-check-line text-primary-400"></i>
                  免安装即点即看
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400 bg-secondary-50 px-3 py-1.5 rounded-full">
                  <i className="ri-check-line text-primary-400"></i>
                  流畅下拉式阅读
                </span>
                <span className="inline-flex items-center gap-1.5 text-xs text-foreground-400 bg-secondary-50 px-3 py-1.5 rounded-full">
                  <i className="ri-check-line text-primary-400"></i>
                  自适应手机屏幕
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}